import React, { useContext } from "react";

import { CaseContext } from "contexts/CaseContext";

import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";

import SeverityChip from "components/SeverityChip/SeverityChip";

import caseStatusTableStyle from "assets/jss/default/components/caseStatusTableStyle";

const useStyles = makeStyles(caseStatusTableStyle);

export function SeverityChips() {
  const classes = useStyles();

  const { loading, error, caseData } = useContext(CaseContext);

  if (loading || error || !caseData) return <SeverityChipsSkeleton />;

  return (
    <>
      <Grid item xs={12} md={2}>
        <div className={classes.caseStatusWrapper}>
          <Typography variant="h5" align="center">
            Diagnostics
          </Typography>
          <SeverityChip
            id="diagnostics-severity"
            severity={caseData?.diagnostic_severity}
            fullWidth={true}
          />
        </div>
      </Grid>
      <Grid item xs={12} md={2}>
        <div className={classes.caseStatusWrapper}>
          <Typography variant="h5" align="center">
            Inspection
          </Typography>
          <SeverityChip
            id="inspection-severity"
            severity={caseData?.inspection_severity}
            fullWidth={true}
          />
        </div>
      </Grid>
    </>
  );
}

function SeverityChipsSkeleton() {
  const classes = useStyles();

  return (
    <>
      <Grid item xs={12} md={2}>
        <div className={classes.caseStatusWrapper}>
          <Skeleton variant="text" />
          <Skeleton
            variant="rectangular"
            width={74}
            height={29}
            animation="wave"
          />
        </div>
      </Grid>
      <Grid item xs={12} md={2}>
        <div className={classes.caseStatusWrapper}>
          <Skeleton variant="text" />
          <Skeleton
            variant="rectangular"
            width={74}
            height={29}
            animation="wave"
          />
        </div>
      </Grid>
    </>
  );
}

SeverityChips.propTypes = {};
